export function StarIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M10.583 3.83c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666L12 18.02l-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.812-4.006-3.036c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748zM12 5.846l-1.292 3.718A1.5 1.5 0 019.32 10.57l-3.935.08 3.137 2.378a1.5 1.5 0 01.53 1.63l-1.14 3.767 3.23-2.248a1.5 1.5 0 011.714 0l3.23 2.248-1.14-3.767a1.5 1.5 0 01.53-1.63l3.137-2.378-3.935-.08a1.5 1.5 0 01-1.387-1.007L12 5.846z"
      ></path>
    </svg>
  );
}
